<template>
  <div class="p-p-4">
    <template v-if="editedCompany">
      <div class="p-fluid p-my-3 p-pl-2">
        <div class="p-field p-grid p-pt-4">
          <span class="p-float-label">
            <InputText v-model="editedCompany.companyname" id="companyname" type="text" class="p-inputtext-lg" />
            <label for="companyname" class="mandatory">Bedriftsnavn</label>
          </span>
        </div>
        <div class="p-field p-grid p-pt-4">
          <span class="p-float-label">
            <InputText v-model="editedCompany.organizationnumber" id="organizationnumber" type="text" class="p-inputtext-lg" />
            <label for="organizationnumber" class="mandatory">Organisasjonsnummer</label>
          </span>
        </div>
      </div>
    </template>
    <Message v-for="(error, index) in errors" severity="error" :key="index">{{error}}</Message>
    <div class="p-d-flex p-jc-end p-mb-3 p-pt-5">
      <Button label="Lagre" icon="pi pi-save" class="p-mr-2" @click="save()" />
    </div>
  </div>
</template>

<script>
import { onLogin } from '@/store/onLogin'
import Message from 'primevue/message';

export default {
name: 'companyEdit',

components:{
  Message
},

data(){
  return{
    editedCompany: null,
    addUserAccsess: [],
    errors: []
  }
},

props: {
  new: {
    type: Boolean, 
    default: false,  
  }
},

mounted(){
  if(this.new){
    this.$store.dispatch('employees/inspect', {type: 'all'})
    this.editedCompany = {
      companyname: null,
      organizationnumber: null, 
    }
  }
  else{
    this.$store.dispatch('companies/inspect', this.$route.params.id).then((company) => {
      this.editedCompany = company
    })
  }
},

methods: {
  save(){
    this.errors = []
    /* checks if company exisist */
    this.$db.collection('companies').where('organizationnumber', '==', this.editedCompany.organizationnumber).get().then(companies => {
      
      if(companies.size){
        this.errors.push('En bedrift med det org.nr finnes allerede!')
      }
      else{
        this.$store.dispatch('companies/save', this.editedCompany)
          .then((data) => {
            data.get().then(company => {
              this.$store.dispatch('companies/current', company.data()).then(() => {
                onLogin({email: this.$store.getters['user/get'].Email, store: this.$store}).then(() => {
                  if(this.new){
                    this.$toast.add({
                      severity:'success',
                      summary: 'Opprettet',
                      detail: `${this.editedCompany.companyname} er opprettet`,
                      life: 5000,
                    })
                  }
                  else{
                    this.$toast.add({
                      severity:'success',
                      summary: 'Lagret',
                      detail: `Endringer til ${this.editedCompany.companyname} er lagret`,
                      life: 5000,
                    })
                  }
                  
                  this.$router.push({name: 'company', params: { id: company.id }})
                })
              })
              
            })
          })
          
      }
    })
  },
  
  addToUserList(users){
    this.addUserAccsess = users
  }
},

computed:{
  employees(){
    return this.$store.getters['employees/inspect']
  }
}

}
</script>